/**
 * Mocked permissions
 */
export const MOCK_PERMISSIONS = [
  'AddNewBot',
  'UsersPage',
  'UserDetails',
  'BlockUser',
  'FlowEditorPage',
  'AnalyticsPage',
  'AnalyticsExport',
  'CampaignsPage',
  'ArchiveCampaign',
  'FeedbacksPage',
  'ArchiveFeedback',
  'BotSettingsPage',
];
